const { routes }: any = window

interface PredictiveSearchParams {
  searchQuery: string
  sectionParam: string
  limitParam: string
  fieldsParam: string
}

export class PredictiveSearchAPI {
  get(params: PredictiveSearchParams): Promise<string> {
    const { searchQuery, sectionParam, limitParam, fieldsParam } = params
    const baseUrl = routes.predictive_search_url

    return fetch(
      `${baseUrl}?q=${searchQuery}&${limitParam}&${sectionParam}&${fieldsParam}`,
    ).then(response => response.text())
  }
}
